<template>
	<div>

		<section id="home" class="video-hero">
			<div class="overlay top-bk"></div>
		</section>
		<div class="colorlib-work-featured colorlib-bg-white">
			<div class="container">

				<div class="row">
					<div class="col-md-8 col-md-offset-2 text-center colorlib-heading animate-box">
						<h1> {{ $tc('candidate', 1) }}  <i class="icon-lightbulb"></i></h1>
						<p v-html="$t('site.features.subtitle')" class="text-justify"></p>
					</div>
					<div class="col-md-04">
						<img 
							src="@/assets/img/process_flow.svg" 
							class="img-drawing"
						>
					</div>
				</div>

			<div class="colorlib-services colorlib-bg-white_ mt-3">
				<div class="container">
					<div class="row">
						<div class="col-md-4 text-center animate-box">
							<div class="services">
								<span class="icon">
									<i class="icon-browser"></i>
								</span>
								<div class="desc">
									<h2>{{ $tc('recruitment', 1) }}</h2>
									<div v-html="$t('site.home.features.process.desc')"></div>
								</div>
							</div>
						</div>
						<div class="col-md-4 text-center animate-box">
							<div class="services">
								<span class="icon">
									<i class="icon-download"></i>
								</span>
								<div class="desc">
									<h2>{{ $tc('profile_bank', 2) }}</h2>
									<div v-html="$t('site.home.features.profile_and_cvs.desc')"></div>
								</div>
							</div>
						</div>
						<div class="col-md-4 text-center animate-box">
							<div class="services">
								<span class="icon">
									<i class="icon-lightbulb"></i>
								</span>
								<div class="desc">
									<h2>{{ $tc('custom_features', 2) }}</h2>
									<div v-html="$t('site.home.features.custom_features.desc')"></div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			</div>
		</div>

	</div>
</template>

<script>
export default {
	name: "AppTemplate",
  mounted() {
		// this.$helpers.ga.openPage('features');
		this.$helpers.scrollTop(0);
		this.anchorHashCheck();
  },
  methods: {
    changeCategory(id) {
      this.setFilterCategoryId({ id: id });
      console.log(id);
		},
    anchorHashCheck() {
      if (window.location.hash === this.$route.hash) {
        const el = document.getElementById(this.$route.hash.slice(1))
        if (el) {
          window.scrollTo(0, el.offsetTop)
        }
      }
    },
  }
};
</script>

<style scoped lang="scss">

	.title-features {
		font-size: 1.5em !important;
	}

	.animate-box.feature-img  {
		display: flex;
		.img-drawing {
			width: 80% !important;
			@media screen and (max-width: 779px) {
				width: 70% !important;
				margin: 0 auto;
			}
	} 
	}
</style>